// utils/axiosWithInterceptor.js
import axios from "axios";
import { getAccessToken } from "../auth/DriverAuth";

const api = axios.create({
  baseURL: "https://werideapp-backend-production.up.railway.app",
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for refresh token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken");
        const response = await axios.post("https://werideapp-backend-production.up.railway.app/auth/refresh-token", {
          refresh_token: refreshToken,
        });

        const { access_token } = response.data;
        localStorage.setItem("accessToken", access_token);

        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        return api(originalRequest);
      } catch (refreshError) {
        localStorage.clear();
        window.location.href = "/driver/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
